export enum LicenseSuiteTypes {
    AuraSoftwareSuite_L = "Aura Software Suite L",
    AuraSoftwareSuite_M_to_L = "Aura Software Suite M to L",
    AuraSoftwareSuite_M = "Aura Software Suite M",
    AuraSoftwareSuite_S_to_L = "Aura Software Suite S to L",
    AuraSoftwareSuite_S_to_M = "Aura Software Suite S to M",
    AuraSoftwareSuite_S = "Aura Software Suite S",
    AuraSoftwareSuite_S_Yearly="Aura Software Suite S (yearly)",
    AuraSoftwareSuite_S_to_M_Yearly="Aura Software Suite S to M (yearly)",
    AuraSoftwareSuite_S_to_L_Yearly="Aura Software Suite S to L (yearly)",
    AuraSoftwareSuite_M_Yearly="Aura Software Suite M (yearly)",
    AuraSoftwareSuite_M_to_LYearly="Aura Software Suite M to L (yearly)",
    AuraSoftwareSuite_L_Yearly="Aura Software Suite L (yearly)"
}

export const suiteMap = new Map<string, string>([

    [LicenseSuiteTypes.AuraSoftwareSuite_L_Yearly, "L"],
    [LicenseSuiteTypes.AuraSoftwareSuite_M_to_LYearly, "L"],
    [LicenseSuiteTypes.AuraSoftwareSuite_S_to_L_Yearly, "L"],
    [LicenseSuiteTypes.AuraSoftwareSuite_M_to_L, "L"],
    [LicenseSuiteTypes.AuraSoftwareSuite_S_to_L, "L"],
    [LicenseSuiteTypes.AuraSoftwareSuite_L, "L"],

    [LicenseSuiteTypes.AuraSoftwareSuite_M_Yearly, "M"],
    [LicenseSuiteTypes.AuraSoftwareSuite_S_to_M_Yearly, "M"],
    [LicenseSuiteTypes.AuraSoftwareSuite_S_to_M, "M"],
    [LicenseSuiteTypes.AuraSoftwareSuite_M, "M"],

    [LicenseSuiteTypes.AuraSoftwareSuite_S_Yearly, "S"],
    [LicenseSuiteTypes.AuraSoftwareSuite_S, "S"],

  ]);


export const getLicenseType = (licenseType:string) => {
    const licenseTypes = Array.from(suiteMap.keys());
    for (const size of licenseTypes) {
        if (licenseType.includes(size)) {
            return suiteMap.get(size);
        }
      }
      return '';
}